// Zero-dependency error type for the API layer.
//
// Deliberately its own leaf module (imported by `api.ts`, `auth/authErrors.ts`,
// and ~40 call sites) so that `auth/authErrors.ts` can `instanceof`-check it
// WITHOUT importing `api.ts` — which pulls in `auth/keycloak.ts` and would
// otherwise form an `authErrors → api → keycloak → authErrors` import cycle
// once `keycloak.ts` reuses `isTransientAuthError`. `api.ts` re-exports both
// symbols, so existing `import { ApiRequestError, type ApiError } from '.../api'`
// call sites keep resolving unchanged.

export type ApiError = {
  message?: string;
  details?: string[] | string;
};

export class ApiRequestError extends Error {
  readonly status: number;
  readonly details?: string[] | string;
  readonly payload?: unknown;

  constructor(
    message: string,
    status: number,
    details?: string[] | string,
    payload?: unknown,
  ) {
    super(message);
    this.name = 'ApiRequestError';
    this.status = status;
    this.details = details;
    this.payload = payload;
  }
}
